module.exports = __webpack_public_path__ + "assets/0e264f812b1f4d405862600a992e00c4.png";